module.exports = __webpack_public_path__ + "img/emoji_74.4bd9bde3.png";